import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import DashboardLayout from "../../Layout/DashboardLayout";
import DashboardTopbar from "../../Layout/DashboardTopbar";
import useTokenBalance from "../../hooks/useTokenBalance";
import HelpCenterSection from "./HelpCenterSection";
import { HELP_CENTER_SECTIONS } from "./helpCenterData";
import "./help-center.css";

const HelpCenter = () => {
  const { t } = useTranslation("common");
  const { tokenBalance, tokensLoading } = useTokenBalance();
  const location = useLocation();
  const [expandedId, setExpandedId] = useState(HELP_CENTER_SECTIONS[0]?.id || null);

  const displayTokenBalance = tokensLoading ? "…" : tokenBalance;

  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (hash && HELP_CENTER_SECTIONS.some((section) => section.id === hash)) {
      setExpandedId(hash);
    }
  }, [location.hash]);

  const scrollToSection = (sectionId) => {
    setExpandedId(sectionId);
    window.requestAnimationFrame(() => {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  return (
    <DashboardLayout>
      <div className="dashboard-page help-center-page">
        <DashboardTopbar title={t("Help Center")} tokenBalance={displayTokenBalance} />

        <div className="page-content">
          <div className="page-header">
            <h1>{t("Help Center")}</h1>
            <p>{t("helpCenter.pageIntro")}</p>
          </div>

          <div className="help-center-layout">
            <nav className="help-center-nav card" aria-label={t("Help Center")}>
              <div className="card-header">
                <div className="card-title">{t("helpCenter.common.topics")}</div>
              </div>
              <ul className="help-center-nav-list">
                {HELP_CENTER_SECTIONS.map((section) => (
                  <li key={section.id}>
                    <button
                      type="button"
                      className={`help-center-nav-item${
                        expandedId === section.id ? " active" : ""
                      }`}
                      onClick={() => scrollToSection(section.id)}>
                      {t(section.titleKey)}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="help-center-content">
              {HELP_CENTER_SECTIONS.map((section) => (
                <HelpCenterSection
                  key={section.id}
                  section={section}
                  expanded={expandedId === section.id}
                  onToggle={() =>
                    setExpandedId((current) => (current === section.id ? null : section.id))
                  }
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default HelpCenter;
